export default "__VITE_ASSET__CiskNLI$__"